<div class="userprofile-tabview">
  <!-- Tab Headers -->
  <div class="tab-headers">
    <p-button type="button" [text]="true" class="tab-header" [class.active]="tabIndex === 0" label="User Profile"
      (onClick)="setActiveTab(0)" />
    @if (!isAppWide) {
      <p-button type="button" [text]="true" class="tab-header" [class.active]="tabIndex === 1" label="User Settings"
        (onClick)="setActiveTab(1)" />
    }
    @if (!isAppWide) {
      <p-button type="button" [text]="true" class="tab-header" [class.active]="tabIndex === 2" label="User Notifications"
        *checkAccess="Claims.manage_email_notifications" (onClick)="setActiveTab(2)" />
    }
  </div>
  
  <!-- Tab Content -->
  <div class="tab-content">
    @if (tabIndex === 0) {
      <myuserinformation #myInfoComp />
    }
    @if (!isAppWide && tabIndex === 1) {
      <myusersettings #mySettingsComp [appWideRoleStatus]="isAppWide" />
    }
    @if (!isAppWide && tabIndex === 2) {
      <myusernotifications #myNotificationsComp />
    }
  </div>
</div>
